<template>
  <div id="app">
    <section class="loginBox" v-if="isLogin">
      <div class="" v-if="isShow">
        <preload @preloadComplete="handlePreloadComplete" KEY="preloadAppKey"></preload>
      </div>
      <div v-show="!isShow">
        <router-view ></router-view>
        <audio ref="audio" style="display: none;" controls  loop id="audio">
          <source src="../public/guangming_milk/music/final.mp3" />
          您的浏览器不支持 audio 元素。
        </audio>
        <div class="musicPng stop" id="palyBtn" @click="playPause">
          <img src="../public/guangming_milk/music/play.png" class="playImg" />
          <img src="../public/guangming_milk/music/stop.png" class="stopImg" />
        </div>
      </div>
    </section>

    <section class="notLoginBox" v-else>
      <van-loading type="spinner" color="#eb5d62" size="24" style="display: flex;justify-content: center;margin-top: 7.8vw;">
      </van-loading>
    </section>

  </div>
</template>

<script>
import preload from "@/components/preload";
export default {
  name: 'App',
  components: {
    preload
  },
  data(){
    return{
      isShow: true,
      isLogin:true,
      music:''
    }
  },
  watch: {
    immediate: true,
    '$route'(to, from) {
      // this.$config.handleNavTitle(this.$route.meta.navTitle);
      this.judgeLogin(to);
      this.$config.wxShare('长寿之乡的新鲜','点击开启，玻璃小樽的「新鲜」旅行志',this)
    },
  },
  created() {
  },
  mounted() {
    console.log(process.env.VUE_APP_BASE_URL,)
    this.judgeLogin()
    this.audioPlayer('audio')
    this.$config.wxShare('长寿之乡的新鲜','点击开启，玻璃小樽的「新鲜」旅行志',this)
    console.log(this.obtainCurrPlatform(),'判断是pc还是h5')
  },
  methods:{
    judgeLogin() {
      return
      if (process.env.NODE_ENV == 'development'||process.env.NODE_ENV == 'test'){
        // sessionStorage.setItem('token',this.$config.defaultToken)
      }
      // console.log(process.env.NODE_ENV, 'process.env.NODE_ENV');
      if (!this.$config.getCookie('headimgurl')){
        //登录则显示页面
        this.$config.wxLogin(this)
      }else{
        this.isLogin = true;
      }
    },
    handlePreloadComplete(bool) {
      // console.log(bool, 'handlePreloadComplete');
      this.isShow = bool;
      this.playPause();
    },
    obtainCurrPlatform:()=>{
      // 判断当前使用的平台 PC PHONE
      let ios = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      let android = /(Android)/i.test(navigator.userAgent);
      // console.log(ios,android)
      if(ios||android){
        const deviceWidth = document.documentElement.clientWidth || document.body.clientWidth;
        // deviceWidth = 750px(设计图w)
        // document.querySelector('html').style.fontSize = deviceWidth / 100 / 7.5 + 'px';
        document.documentElement.style.fontSize = deviceWidth / 100 / 7.5 + 'px';
        return 'PHONE'
      }else{
        return 'PC'
      }
    },
    audioPlayer(id) {
      var that = this;
      let audio = document.getElementById(id);

      if (that.isWeixin()) {
        document.addEventListener(
            'WeixinJSBridgeReady',
            function() {
              audio.pause();
            },
            false
        );

        // 添加 getNetworkType 的判断原因, 请看问题分析2

        if (typeof window.WeixinJSBridge == 'object' && typeof window.WeixinJSBridge.invoke == 'function') {
          window.WeixinJSBridge.invoke('getNetworkType', {}, function() {
            audio.pause();
          });
        }
      } else {
        audio.pause();

        function touchPlay() {
          audio.pause();
          document.removeEventListener('touchstart', touchPlay, false);
        }
        if (audio.paused) {
          document.addEventListener('touchstart', touchPlay, false);
        }
      }
    },
    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      return /micromessenger/.test(ua);
    },
    playPause() {
      var params = $('#audio')[0].paused;
      if (params) {
        $('#audio')[0].play();

        $('#palyBtn')
            .addClass('play')
            .removeClass('stop');
      } else {
        $('#audio')[0].pause();
        $('#palyBtn')
            .addClass('stop')
            .removeClass('plays');
      }
    },
  }
}
</script>

<style>
#app {
  overflow: hidden;
  /*background-color: #fdd7c2;*/
}

.musicPng{
  position: fixed;
  width:60px;
  height:60px;
  z-index: 1000;
  right: 10px;
  top: 10px;
}
.musicPng>img{
  width: 100%;
  height: 100%;
}
.musicPng.play .stopImg{
  display: none;
}
.musicPng.play .playImg{
  display: block;
}
.musicPng.stop .stopImg{
  display: block;
}
.musicPng.stop .playImg{
  display: none;
}
.musicPng.play .playImg {
  animation: xz 2s linear infinite;
  -o-animation:xz 2s linear infinite ;
  -webkit-animation: xz 2s linear infinite;
}

@keyframes xz {
  0%{-webkit-transform:rotate(0deg);}
  25%{-webkit-transform:rotate(90deg);}
  50%{-webkit-transform:rotate(180deg);}
  75%{-webkit-transform:rotate(270deg);}
  100%{-webkit-transform:rotate(360deg);}
}
@-o-keyframes xz {
  0%{-webkit-transform:rotate(0deg);}
  25%{-webkit-transform:rotate(90deg);}
  50%{-webkit-transform:rotate(180deg);}
  75%{-webkit-transform:rotate(270deg);}
  100%{-webkit-transform:rotate(360deg);}
}
@-webkit-keyframes xz {
  0%{-webkit-transform:rotate(0deg);}
  25%{-webkit-transform:rotate(90deg);}
  50%{-webkit-transform:rotate(180deg);}
  75%{-webkit-transform:rotate(270deg);}
  100%{-webkit-transform:rotate(360deg);}
}
</style>
